{
  "generated": "2026-08-20",
  "bikes": {
    "benno-46er-class-3": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-46er-class-3-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-46er-class-3-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno 46er 10D",
        "alt": "Benno 46er 10D — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-46er-class-3-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-46er-class-3-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1080,
        "brand": "benno",
        "model": "Benno 46er 10D",
        "alt": "Benno 46er 10D — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/benno-46er-class-3-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/benno-46er-class-3-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 819,
          "brand": "benno",
          "model": "Benno 46er 10D",
          "alt": "Benno 46er 10D — in use 2"
        }
      ]
    },
    "benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1440,
        "height": 860,
        "brand": "benno",
        "model": "Benno Boost 10D Evo 5",
        "alt": "Benno Boost 10D Evo 5 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno Boost 10D Evo 5",
        "alt": "Benno Boost 10D Evo 5 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/benno-boost-10d-evo-5-performance-sport-class-3-ebike-400wh-easy-on-anthracite-gray-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 1080,
          "brand": "benno",
          "model": "Benno Boost 10D Evo 5",
          "alt": "Benno Boost 10D Evo 5 — in use 2"
        }
      ]
    },
    "benno-remi-demiperf-sport": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remi-demiperf-sport-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remi-demiperf-sport-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno RemiDemi 9D Evo 2",
        "alt": "Benno RemiDemi 9D Evo 2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remi-demiperf-sport-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remi-demiperf-sport-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno RemiDemi 9D Evo 2",
        "alt": "Benno RemiDemi 9D Evo 2 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/benno-remi-demiperf-sport-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/benno-remi-demiperf-sport-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 1280,
          "brand": "benno",
          "model": "Benno RemiDemi 9D Evo 2",
          "alt": "Benno RemiDemi 9D Evo 2 — in use 2"
        }
      ]
    },
    "benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno RemiDemi 9D Evo 2",
        "alt": "Benno RemiDemi 9D Evo 2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno RemiDemi 9D Evo 2",
        "alt": "Benno RemiDemi 9D Evo 2 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/benno-remidemi-9d-evo-2-performance-class-1-ebike-400wh-easy-on-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 1280,
          "brand": "benno",
          "model": "Benno RemiDemi 9D Evo 2",
          "alt": "Benno RemiDemi 9D Evo 2 — in use 2"
        }
      ]
    },
    "benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1080,
        "brand": "benno",
        "model": "Benno RemiDemi XL 9D Evo 3",
        "alt": "Benno RemiDemi XL 9D Evo 3 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1280,
        "brand": "benno",
        "model": "Benno RemiDemi XL 9D Evo 3",
        "alt": "Benno RemiDemi XL 9D Evo 3 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/benno-remidemi-xl-9d-evo-3-performance-line-sport-class-3-ebike-545wh-easy-on-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 1280,
          "brand": "benno",
          "model": "Benno RemiDemi XL 9D Evo 3",
          "alt": "Benno RemiDemi XL 9D Evo 3 — in use 2"
        }
      ]
    },
    "flyer-flex-blue-m": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/flyer-flex-blue-m-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/flyer-flex-blue-m-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 5000,
        "height": 3000,
        "brand": "flyer",
        "model": "Flyer Flex",
        "alt": "Flyer Flex — product photo"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-flex-blue-m-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-flex-blue-m-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 5000,
          "height": 3000,
          "brand": "flyer",
          "model": "Flyer Flex",
          "alt": "Flyer Flex — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-flex-blue-m-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-flex-blue-m-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 5000,
          "height": 3000,
          "brand": "flyer",
          "model": "Flyer Flex",
          "alt": "Flyer Flex — detail 2"
        }
      ]
    },
    "flyer-via-pro": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/flyer-via-pro-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/flyer-via-pro-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 5000,
        "height": 3000,
        "brand": "flyer",
        "model": "Flyer Via Pro",
        "alt": "Flyer Via Pro — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/flyer-via-pro-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/flyer-via-pro-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 3000,
        "height": 1800,
        "brand": "flyer",
        "model": "Flyer Via Pro",
        "alt": "Flyer Via Pro — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-via-pro-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-via-pro-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3000,
          "height": 1800,
          "brand": "flyer",
          "model": "Flyer Via Pro",
          "alt": "Flyer Via Pro — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-via-pro-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-via-pro-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3000,
          "height": 1800,
          "brand": "flyer",
          "model": "Flyer Via Pro",
          "alt": "Flyer Via Pro — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-via-pro-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-via-pro-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3000,
          "height": 1800,
          "brand": "flyer",
          "model": "Flyer Via Pro",
          "alt": "Flyer Via Pro — detail 2"
        }
      ]
    },
    "flyer-via-yellow-sm": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/flyer-via-yellow-sm-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/flyer-via-yellow-sm-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 5000,
        "height": 3000,
        "brand": "flyer",
        "model": "Flyer Via",
        "alt": "Flyer Via — product photo"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-via-yellow-sm-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-via-yellow-sm-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 5000,
          "height": 3000,
          "brand": "flyer",
          "model": "Flyer Via",
          "alt": "Flyer Via — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/flyer-via-yellow-sm-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/flyer-via-yellow-sm-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 5000,
          "height": 3000,
          "brand": "flyer",
          "model": "Flyer Via",
          "alt": "Flyer Via — detail 2"
        }
      ]
    },
    "gazelle-arroyo-c8-hmb-elite-l-saturn-blue": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 3000,
        "height": 2121,
        "brand": "gazelle",
        "model": "Gazelle Arroyo C7 HMB Elite",
        "alt": "Gazelle Arroyo C7 HMB Elite — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 4000,
        "height": 2672,
        "brand": "gazelle",
        "model": "Gazelle Arroyo C7 HMB Elite",
        "alt": "Gazelle Arroyo C7 HMB Elite — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/gazelle-arroyo-c8-hmb-elite-l-saturn-blue-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 4000,
          "height": 2672,
          "brand": "gazelle",
          "model": "Gazelle Arroyo C7 HMB Elite",
          "alt": "Gazelle Arroyo C7 HMB Elite — in use 2"
        }
      ]
    },
    "gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 3000,
        "height": 2121,
        "brand": "gazelle",
        "model": "Gazelle Medeo T9 HMB",
        "alt": "Gazelle Medeo T9 HMB — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": true,
        "width": 2133,
        "height": 3200,
        "brand": "gazelle",
        "model": "Gazelle Medeo T9 HMB",
        "alt": "Gazelle Medeo T9 HMB — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1920,
          "height": 1280,
          "brand": "gazelle",
          "model": "Gazelle Medeo T9 HMB",
          "alt": "Gazelle Medeo T9 HMB — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3000,
          "height": 1688,
          "brand": "gazelle",
          "model": "Gazelle Medeo T9 HMB",
          "alt": "Gazelle Medeo T9 HMB — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/gazelle-medeo-t9-hmb-usa-l45-iced-blue-s9-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3000,
          "height": 1688,
          "brand": "gazelle",
          "model": "Gazelle Medeo T9 HMB",
          "alt": "Gazelle Medeo T9 HMB — detail 2"
        }
      ]
    },
    "packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Packster 70 vario",
        "alt": "Packster 70 vario — product photo"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Packster 70 vario",
          "alt": "Packster 70 vario — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/packster-70-vario-testbike-r-m-bike-code-f00955_0211400718152406-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Packster 70 vario",
          "alt": "Packster 70 vario — detail 2"
        }
      ]
    },
    "riese-and-muller-nevo-4-gt-vario": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Nevo4 GT vario",
        "alt": "Nevo4 GT vario — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Nevo4 GT vario",
        "alt": "Nevo4 GT vario — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1068,
          "brand": "riese-muller",
          "model": "Nevo4 GT vario",
          "alt": "Nevo4 GT vario — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-and-muller-nevo-4-gt-vario-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1066,
          "brand": "riese-muller",
          "model": "Nevo4 GT vario",
          "alt": "Nevo4 GT vario — detail 2"
        }
      ]
    },
    "riese-and-muller-packster-70-touring": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-packster-70-touring-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-packster-70-touring-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Packster2 70 Touring",
        "alt": "Packster2 70 Touring — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-packster-70-touring-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-packster-70-touring-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1624,
        "height": 1080,
        "brand": "riese-muller",
        "model": "Packster2 70 Touring",
        "alt": "Packster2 70 Touring — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-and-muller-packster-70-touring-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-and-muller-packster-70-touring-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Packster2 70 Touring",
          "alt": "Packster2 70 Touring — in use 2"
        }
      ]
    },
    "riese-and-muller-tinker-2": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-tinker-2-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-tinker-2-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Tinker 2",
        "alt": "Tinker 2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-and-muller-tinker-2-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-and-muller-tinker-2-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Tinker 2",
        "alt": "Tinker 2 — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-and-muller-tinker-2-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-and-muller-tinker-2-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Tinker 2",
          "alt": "Tinker 2 — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-and-muller-tinker-2-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-and-muller-tinker-2-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Tinker 2",
          "alt": "Tinker 2 — detail 2"
        }
      ]
    },
    "riese-muller-carrie-vario-aqua": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-carrie-vario-aqua-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-carrie-vario-aqua-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Carrie",
        "alt": "Carrie — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-carrie-vario-aqua-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-carrie-vario-aqua-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 1067,
        "brand": "riese-muller",
        "model": "Carrie",
        "alt": "Carrie — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-carrie-vario-aqua-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-carrie-vario-aqua-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Carrie",
          "alt": "Carrie — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-carrie-vario-aqua-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-carrie-vario-aqua-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1890,
          "height": 1063,
          "brand": "riese-muller",
          "model": "Carrie",
          "alt": "Carrie — detail 1"
        }
      ]
    },
    "riese-muller-carrie-vario-shadow": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-carrie-vario-shadow-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-carrie-vario-shadow-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Carrie",
        "alt": "Carrie — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-carrie-vario-shadow-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-carrie-vario-shadow-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 1067,
        "brand": "riese-muller",
        "model": "Carrie",
        "alt": "Carrie — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-carrie-vario-shadow-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-carrie-vario-shadow-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Carrie",
          "alt": "Carrie — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-carrie-vario-shadow-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-carrie-vario-shadow-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1890,
          "height": 1063,
          "brand": "riese-muller",
          "model": "Carrie",
          "alt": "Carrie — detail 1"
        }
      ]
    },
    "riese-muller-load-60-touring-hs-grey": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1241,
        "brand": "riese-muller",
        "model": "Load 60 Touring HS",
        "alt": "Load 60 Touring HS — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Load 60 Touring HS",
        "alt": "Load 60 Touring HS — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Load 60 Touring HS",
          "alt": "Load 60 Touring HS — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-load-60-touring-hs-grey-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Load 60 Touring HS",
          "alt": "Load 60 Touring HS — detail 2"
        }
      ]
    },
    "riese-muller-load4-75-vario": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load4-75-vario-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load4-75-vario-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Load4 75 vario",
        "alt": "Load4 75 vario — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load4-75-vario-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load4-75-vario-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Load4 75 vario",
        "alt": "Load4 75 vario — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-load4-75-vario-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-load4-75-vario-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Load4 75 vario",
          "alt": "Load4 75 vario — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-load4-75-vario-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-load4-75-vario-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Load4 75 vario",
          "alt": "Load4 75 vario — detail 2"
        }
      ]
    },
    "riese-muller-load5-75-hs-touring-peanut": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 8688,
        "height": 5792,
        "brand": "riese-muller",
        "model": "Load5 75 Touring",
        "alt": "Load5 75 Touring — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1890,
        "height": 1063,
        "brand": "riese-muller",
        "model": "Load5 75 Touring",
        "alt": "Load5 75 Touring — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-load5-75-hs-touring-peanut-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1624,
          "height": 1080,
          "brand": "riese-muller",
          "model": "Load5 75 Touring",
          "alt": "Load5 75 Touring — in use 2"
        }
      ]
    },
    "riese-muller-multicharger2-family-mixte-gt": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Multicharger2 Family Mixte GT",
        "alt": "Multicharger2 Family Mixte GT — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 1080,
        "brand": "riese-muller",
        "model": "Multicharger2 Family Mixte GT",
        "alt": "Multicharger2 Family Mixte GT — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1080,
          "brand": "riese-muller",
          "model": "Multicharger2 Family Mixte GT",
          "alt": "Multicharger2 Family Mixte GT — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-multicharger2-family-mixte-gt-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Multicharger2 Family Mixte GT",
          "alt": "Multicharger2 Family Mixte GT — detail 1"
        }
      ]
    },
    "riese-muller-multitinker-wrj2mt1m4nd201091": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Multitinker2",
        "alt": "Multitinker2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1890,
        "height": 1063,
        "brand": "riese-muller",
        "model": "Multitinker2",
        "alt": "Multitinker2 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201091-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1624,
          "height": 1080,
          "brand": "riese-muller",
          "model": "Multitinker2",
          "alt": "Multitinker2 — in use 2"
        }
      ]
    },
    "riese-muller-multitinker-wrj2mt1m4nd201325": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Multitinker2",
        "alt": "Multitinker2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1890,
        "height": 1063,
        "brand": "riese-muller",
        "model": "Multitinker2",
        "alt": "Multitinker2 — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-multitinker-wrj2mt1m4nd201325-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1624,
          "height": 1080,
          "brand": "riese-muller",
          "model": "Multitinker2",
          "alt": "Multitinker2 — in use 2"
        }
      ]
    },
    "riese-muller-nevo4-gt-vario-hs": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Nevo4 GT vario",
        "alt": "Nevo4 GT vario — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Nevo4 GT vario",
        "alt": "Nevo4 GT vario — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1068,
          "brand": "riese-muller",
          "model": "Nevo4 GT vario",
          "alt": "Nevo4 GT vario — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-nevo4-gt-vario-hs-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1066,
          "brand": "riese-muller",
          "model": "Nevo4 GT vario",
          "alt": "Nevo4 GT vario — detail 2"
        }
      ]
    },
    "riese-muller-tinker-2": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-tinker-2-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-tinker-2-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1860,
        "height": 1240,
        "brand": "riese-muller",
        "model": "Tinker 2",
        "alt": "Tinker 2 — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/riese-muller-tinker-2-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/riese-muller-tinker-2-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 730,
        "brand": "riese-muller",
        "model": "Tinker 2",
        "alt": "Tinker 2 — in use"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-tinker-2-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-tinker-2-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Tinker 2",
          "alt": "Tinker 2 — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/riese-muller-tinker-2-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/riese-muller-tinker-2-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 1067,
          "brand": "riese-muller",
          "model": "Tinker 2",
          "alt": "Tinker 2 — detail 2"
        }
      ]
    },
    "tern-gsd-p00": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-p00-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-p00-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1200,
        "height": 800,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-p00-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-p00-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-p00-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-p00-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-p00-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-p00-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-gsd-p10": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-p10-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-p10-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-p10-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-p10-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-p10-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-p10-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-p10-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-p10-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-gsd-r14": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-r14-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-r14-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-r14-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-r14-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-r14-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-r14-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-r14-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-r14-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-gsd-s00-lx": {
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-s00-lx-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-s00-lx-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s00-lx-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s00-lx-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s00-lx-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s00-lx-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-gsd-s10-gen3-545wh": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-s10-gen3-545wh-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-s10-gen3-545wh-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-s10-gen3-545wh-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-s10-gen3-545wh-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s10-gen3-545wh-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s10-gen3-545wh-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s10-gen3-545wh-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s10-gen3-545wh-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-gsd-s10-lx": {
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-gsd-s10-lx-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-gsd-s10-lx-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern GSD",
        "alt": "Tern GSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s10-lx-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s10-lx-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-gsd-s10-lx-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-gsd-s10-lx-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern GSD",
          "alt": "Tern GSD — detail 1"
        }
      ]
    },
    "tern-hsd-p00": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p00-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p00-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      }
    },
    "tern-hsd-p10": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p10-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p10-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p10-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p10-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p10-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p10-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p10-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p10-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 4741,
          "height": 3161,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p10-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p10-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 2"
        }
      ]
    },
    "tern-hsd-p10e": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p10e-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p10e-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      }
    },
    "tern-hsd-p5i": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p5i-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p5i-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-p5i-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-p5i-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p5i-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p5i-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p5i-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p5i-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 4741,
          "height": 3161,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-p5i-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-p5i-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 2"
        }
      ]
    },
    "tern-hsd-s00": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-s00-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-s00-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-s00-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-s00-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s00-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s00-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s00-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s00-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 4741,
          "height": 3161,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s00-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s00-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 2"
        }
      ]
    },
    "tern-hsd-s11": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-s11-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-s11-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-hsd-s11-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-hsd-s11-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern HSD",
        "alt": "Tern HSD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s11-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s11-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s11-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s11-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 4741,
          "height": 3161,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-hsd-s11-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-hsd-s11-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 3731,
          "height": 2780,
          "brand": "tern",
          "model": "Tern HSD",
          "alt": "Tern HSD — detail 2"
        }
      ]
    },
    "tern-nbd-p8i": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-nbd-p8i-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-nbd-p8i-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern NBD",
        "alt": "Tern NBD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-nbd-p8i-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-nbd-p8i-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 2000,
        "height": 1000,
        "brand": "tern",
        "model": "Tern NBD",
        "alt": "Tern NBD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-nbd-p8i-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-nbd-p8i-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1000,
          "brand": "tern",
          "model": "Tern NBD",
          "alt": "Tern NBD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-nbd-p8i-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-nbd-p8i-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern NBD",
          "alt": "Tern NBD — detail 1"
        }
      ]
    },
    "tern-nbd-s5i": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-nbd-s5i-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-nbd-s5i-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern NBD",
        "alt": "Tern NBD — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-nbd-s5i-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-nbd-s5i-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 2000,
        "height": 1000,
        "brand": "tern",
        "model": "Tern NBD",
        "alt": "Tern NBD — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-nbd-s5i-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-nbd-s5i-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1000,
          "brand": "tern",
          "model": "Tern NBD",
          "alt": "Tern NBD — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-nbd-s5i-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-nbd-s5i-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern NBD",
          "alt": "Tern NBD — detail 1"
        }
      ]
    },
    "tern-orox-s12-pine-green-large-725wh": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-orox-s12-pine-green-large-725wh-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-orox-s12-pine-green-large-725wh-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Orox",
        "alt": "Tern Orox — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-orox-s12-pine-green-large-725wh-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-orox-s12-pine-green-large-725wh-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1920,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Orox",
        "alt": "Tern Orox — in use"
      }
    },
    "tern-quickhaul-d8": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-quickhaul-d8-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-quickhaul-d8-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Quick Haul",
        "alt": "Tern Quick Haul — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-quickhaul-d8-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-quickhaul-d8-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern Quick Haul",
        "alt": "Tern Quick Haul — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-d8-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-d8-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern Quick Haul",
          "alt": "Tern Quick Haul — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-d8-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-d8-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern Quick Haul",
          "alt": "Tern Quick Haul — detail 1"
        }
      ]
    },
    "tern-quickhaul-long": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-quickhaul-long-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-quickhaul-long-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Quick Haul Long",
        "alt": "Tern Quick Haul Long — product photo"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-long-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-long-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern Quick Haul Long",
          "alt": "Tern Quick Haul Long — detail 1"
        },
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-long-detail-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-long-detail-2-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern Quick Haul Long",
          "alt": "Tern Quick Haul Long — detail 2"
        }
      ]
    },
    "tern-quickhaul-p9": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-quickhaul-p9-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-quickhaul-p9-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Quick Haul",
        "alt": "Tern Quick Haul — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-quickhaul-p9-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-quickhaul-p9-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 1600,
        "height": 900,
        "brand": "tern",
        "model": "Tern Quick Haul",
        "alt": "Tern Quick Haul — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-p9-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-p9-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1600,
          "height": 900,
          "brand": "tern",
          "model": "Tern Quick Haul",
          "alt": "Tern Quick Haul — in use 2"
        }
      ],
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-quickhaul-p9-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-quickhaul-p9-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 1960,
          "height": 1305,
          "brand": "tern",
          "model": "Tern Quick Haul",
          "alt": "Tern Quick Haul — detail 1"
        }
      ]
    },
    "tern-vektron-p10": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-vektron-p10-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-vektron-p10-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Vektron",
        "alt": "Tern Vektron — product photo"
      }
    },
    "tern-vektron-p5i": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-vektron-p5i-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-vektron-p5i-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1960,
        "height": 1305,
        "brand": "tern",
        "model": "Tern Vektron",
        "alt": "Tern Vektron — product photo"
      }
    },
    "tern-vektron-s10": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/tern-vektron-s10-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/tern-vektron-s10-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": [
          255,
          255,
          255
        ],
        "transparent": false,
        "portrait": false,
        "width": 1200,
        "height": 800,
        "brand": "tern",
        "model": "Tern Vektron S10 Gen 3",
        "alt": "Tern Vektron S10 Gen 3 — product photo"
      },
      "gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/tern-vektron-s10-detail-1-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/tern-vektron-s10-detail-1-960.jpg"
            }
          ],
          "fit": "contain",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 960,
          "height": 640,
          "brand": "tern",
          "model": "Tern Vektron S10 Gen 3",
          "alt": "Tern Vektron S10 Gen 3 — detail 1"
        }
      ]
    },
    "urban-arrow-breeze-package": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-breeze-package-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-breeze-package-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 11667,
        "height": 8750,
        "brand": "urban-arrow",
        "model": "Urban Arrow Breeze",
        "alt": "Urban Arrow Breeze — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-breeze-package-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-breeze-package-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 3000,
        "height": 3000,
        "brand": "urban-arrow",
        "model": "Urban Arrow Breeze",
        "alt": "Urban Arrow Breeze — in use"
      }
    },
    "urban-arrow-family-cargo": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-cargo-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-cargo-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 11667,
        "height": 8750,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family",
        "alt": "Urban Arrow Family — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-cargo-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-cargo-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 9504,
        "height": 6336,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family",
        "alt": "Urban Arrow Family — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/urban-arrow-family-cargo-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/urban-arrow-family-cargo-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 8980,
          "height": 5986,
          "brand": "urban-arrow",
          "model": "Urban Arrow Family",
          "alt": "Urban Arrow Family — in use 2"
        }
      ]
    },
    "urban-arrow-family-next": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-next-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-next-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 11667,
        "height": 8750,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family Next",
        "alt": "Urban Arrow Family Next — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-next-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-next-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": true,
        "width": 6336,
        "height": 9504,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family Next",
        "alt": "Urban Arrow Family Next — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/urban-arrow-family-next-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/urban-arrow-family-next-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": true,
          "width": 6336,
          "height": 9504,
          "brand": "urban-arrow",
          "model": "Urban Arrow Family Next",
          "alt": "Urban Arrow Family Next — in use 2"
        }
      ]
    },
    "urban-arrow-family-performance": {
      "studio": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-performance-studio-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-performance-studio-960.jpg"
          }
        ],
        "fit": "contain",
        "ground": null,
        "transparent": true,
        "portrait": false,
        "width": 11667,
        "height": 8750,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family",
        "alt": "Urban Arrow Family — product photo"
      },
      "lifestyle": {
        "srcset": [
          {
            "w": 480,
            "src": "/images/bikes/urban-arrow-family-performance-lifestyle-480.jpg"
          },
          {
            "w": 960,
            "src": "/images/bikes/urban-arrow-family-performance-lifestyle-960.jpg"
          }
        ],
        "fit": "cover",
        "ground": null,
        "transparent": false,
        "portrait": false,
        "width": 9504,
        "height": 6336,
        "brand": "urban-arrow",
        "model": "Urban Arrow Family",
        "alt": "Urban Arrow Family — in use"
      },
      "lifestyle_gallery": [
        {
          "srcset": [
            {
              "w": 480,
              "src": "/images/bikes/urban-arrow-family-performance-lifestyle-2-480.jpg"
            },
            {
              "w": 960,
              "src": "/images/bikes/urban-arrow-family-performance-lifestyle-2-960.jpg"
            }
          ],
          "fit": "cover",
          "ground": null,
          "transparent": false,
          "portrait": false,
          "width": 8980,
          "height": 5986,
          "brand": "urban-arrow",
          "model": "Urban Arrow Family",
          "alt": "Urban Arrow Family — in use 2"
        }
      ]
    }
  },
  "authorization": {
    "authorized": true,
    "date": "2026-08-16",
    "by": "Aaron Hanson (owner decision, in conversation)",
    "over_license_status": "terms-prohibit",
    "note": "Publication authorized by Aaron on 2026-08-16 after the per-brand terms were quoted to him verbatim. Four of the six brands (Benno, Gazelle, Tern, Radio Flyer) prohibit commercial reuse in their own words; two (Riese & Muller, Urban Arrow) have no grant on record in either direction. The prohibition text in `license_status` and `license_evidence` is UNCHANGED and still applies as written -- this field records a business decision taken over it, not a finding that the terms permit use. Scope: these six brands, the assets present on 2026-08-16. Not a standing policy; do not extend it to a new brand without a fresh human decision.",
    "warning": "AUTHORIZED, NOT LICENSED. No brand has granted permission. This records an owner decision taken over the brands' stated terms."
  }
}
